import React from 'react';

export const SelectIcon = (props) => {
  return (
    <svg width="25" height="25" title={props.title} viewBox="-1 -1 18 26" xmlns="http://www.w3.org/2000/svg"><path d="M1.174 0a1.17 1.17 0 0 0-1.17 1.17L0 18.977a1.171 1.171 0 0 0 1.644 1.07l3.922-1.737 2.21 4.992a1.17 1.17 0 0 0 1.545.596l1.604-.71 1.604-.71a1.17 1.17 0 0 0 .596-1.544l-2.21-4.993 3.922-1.736a1.171 1.171 0 0 0 .313-1.936L1.96.303A1.173 1.173 0 0 0 1.175 0z" stroke="#ffffff" fill="none"/></svg>
  );
};

export const LayersIcon = (props) => {
  return (
    <svg width="25" height="25" title={props.title} viewBox="2 0 33 33" xmlns="http://www.w3.org/2000/svg"><path d="M29.09 12.65L35 9.24 19 0 3 9.238l5.91 3.412L3 16.062l5.91 3.412L3 22.886l16 9.239 16-9.239-5.91-3.412L35 16.062l-5.91-3.412zM19 1.743L31.98 9.24 19 16.734 6.02 9.238 19 1.743zm-8.581 11.78L19 18.476l8.581-4.955 4.4 2.54L19 23.558 6.02 16.062l4.399-2.54zm21.562 9.363L19 30.381 6.02 22.886l4.399-2.54L19 25.3l8.581-4.955 4.4 2.54z" fill="#ffffff" fillRule="evenodd"/></svg>
  );
};

export const ExportIcon = (props) => {
  return (
    <svg width="25" height="25" title={props.title} viewBox="107 2 20 23" xmlns="http://www.w3.org/2000/svg"><path d="M117.013 19.523V3.472l4.298 4.493.519-.542L116.642 2l-5.187 5.422.519.543 4.297-4.493v16.05h.742zm8.529-14.806l.001 17.416-.001 1.125h-17.8V4.717h-.741L107 22.133l.001 1.867h19.283V4.717h-.742z" fill="#E1E1E1" fillRule="evenodd"/></svg>
  );
};

export const StudentIcon = (props) => {
  return (
    <svg width="12" height="27" viewBox="334 504 12 27" xmlns="http://www.w3.org/2000/svg"><path d="M337.347 529.833c0 .724.396 1.086 1.19 1.086.795 0 1.192-.362 1.192-1.086v-9.781h1.222v9.782c0 .723.399 1.086 1.193 1.086s1.193-.363 1.193-1.086V513.17h.58v6.002c0 .38.147.656.438.828.29.173.589.173.902 0 .31-.172.464-.448.464-.828v-6.468c0-.69-.264-1.224-.785-1.604-.523-.38-1.25-.57-2.18-.57h-4.771c-.892 0-1.618.173-2.18.518-.562.345-.844.88-.844 1.605v6.882c0 .31.155.534.466.672.31.138.61.138.9 0 .29-.138.438-.362.438-.672v-6.365h.583v16.663h-.001zm.087-22.876c0 .604.242 1.121.726 1.552.486.431 1.067.648 1.744.648.681 0 1.26-.217 1.748-.648.484-.43.726-.957.726-1.578 0-.586-.242-1.096-.726-1.526-.487-.431-1.066-.648-1.748-.648-.677 0-1.258.217-1.744.648-.484.43-.726.948-.726 1.552z" fill="#D8D8D8" fillRule="evenodd"/></svg>
  );
};


/** WEBPACK FOOTER **
 ** ./src/icons/inspector_icons.js
 **/